function isHeightEllipsisActive(e) {
  return e.offsetHeight < e.scrollHeight;
}
function isWidthEllipsisActive(e) {
  return e.offsetWidth < e.scrollWidth;
}
export { isHeightEllipsisActive, isWidthEllipsisActive };


// WEBPACK FOOTER //
// ./scripts/util/checkTruncate.js